import { combineReducers } from "redux";
import { RootAction } from "../types";

function isLoading(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "LOG_IN_REQUEST":
      return true;
    case "LOG_IN_FAILURE":
    case "LOG_IN_SUCCESS":
      return false;
    default:
      return state;
  }
}

function error(state: Error | null = null, action: RootAction): Error | null {
  switch (action.type) {
    case "LOG_IN_REQUEST":
      return null;
    case "LOG_IN_FAILURE":
      return action.payload;
    default:
      return state;
  }
}

export const loginReducer = combineReducers({
  error,
  isLoading,
});

export default loginReducer;



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.ts